import React from "react";

export const Footer = ({ bg, borderColor, textColor, brand }) => (
  <div
    style={{
      padding: "5px 12px",
      borderTop: `1px solid "#000000`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 10,
      color: textColor,
      background: bg,
      flexShrink: 0,
    }}
  >
    <span>
      Powered by{" "}
      <span style={{ color: brand, fontWeight: 600 }}></span>
    </span>
    <span style={{ fontSize: 14, opacity: 0.5 }}>✉</span>
  </div>
);